import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../../colorVars';
import style from './ChartTradingButton.module.css';

export const ChartTradingButton = ({ size, title, setShowChartTrading }) => {
  return (
    <div className={style.div} onClick={() => setShowChartTrading(prev => !prev)} title={title}>
      <svg
        width={size}
        height={size}
        className={style.svg}
        viewBox="0 0 512 512"
        enableBackground="new 0 0 512 512"
        fill={colors.white}
      >
        <path d="M490 489.954v-30.625l-458.778.046L30.625 0 0 .031.628 490z" />
        <path d="M184.822 213.502 94.555 343.306l25.143 17.487 72.995-104.936 143.753 97.54 101.844-169.8 42.14 28.604L490 80.85l-118.549 57.391 41.451 28.129-86.057 143.509z" />
      </svg>
    </div>
  );
};

ChartTradingButton.propTypes = {
  clickHandler: PropTypes.func,
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string
};
